import PreferenceService from './src/preference-service';

export { PreferenceService };
